import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import AppWrapper from '@/components/AppWrapper';
import { FunnelConfigProvider } from '@/context/FunnelConfigContext';
import 'flatpickr/dist/flatpickr.min.css';
import 'jsvectormap/dist/css/jsvectormap.min.css';
import 'simplebar-react/dist/simplebar.min.css';
import '@/assets/scss/app.scss';
import '@/assets/scss/custom.css';

createRoot(document.getElementById('root')).render(<StrictMode>
    <BrowserRouter>
      <AppWrapper>
        <FunnelConfigProvider>
          <App />
        </FunnelConfigProvider>
      </AppWrapper>
    </BrowserRouter>
  </StrictMode>);